import { createRefreshTokenManager, type RefreshTokenManager } from '@crv/shared';
import { clearTokens, getTokens, setTokens, type AuthTokens } from '@crv/shared';

import { useTenancyStore } from '../tenancy/tenancy-store';
import { authClient } from './auth-client';

let onSessionInvalidated: (() => void) | null = null;

export function registerWebSessionInvalidatedHandler(handler: (() => void) | null): void {
  onSessionInvalidated = handler;
}

export const webRefreshTokenManager: RefreshTokenManager = createRefreshTokenManager({
  refreshAccessToken: async (refreshToken) => {
    const response = await authClient.refreshToken({ refreshToken });
    const nextTokens: AuthTokens = {
      accessToken: response.accessToken,
      refreshToken: response.refreshToken,
    };
    setTokens(nextTokens);
    return { accessToken: nextTokens.accessToken, refreshToken: nextTokens.refreshToken };
  },
});

webRefreshTokenManager.setOnLogout(() => {
  clearTokens();
  useTenancyStore.getState().clearSelectedCompany();
  onSessionInvalidated?.();
});

export function syncWebRefreshManagerTokensFromStorage(): void {
  const tokens = getTokens();
  if (tokens) {
    webRefreshTokenManager.setTokens({
      accessToken: tokens.accessToken,
      refreshToken: tokens.refreshToken,
    });
    return;
  }

  webRefreshTokenManager.clearTokens();
}

export function setWebRefreshManagerTokens(tokens: AuthTokens): void {
  webRefreshTokenManager.setTokens({
    accessToken: tokens.accessToken,
    refreshToken: tokens.refreshToken,
  });
}

export function clearWebRefreshManagerTokens(): void {
  webRefreshTokenManager.clearTokens();
}

